<template>
    <div style="position: relative;">
        <div v-if="isLoading" class="loading-overlay">
            <loading loader="dots" :height="170" :width="170" color="#3282b8" background-color="#505273"
                transition="fade" :active="isLoading" :is-full-page="true"></loading>
        </div>


        <div class="col-lg-12" style="position: relative; z-index: 999; padding-top: 20px; padding-bottom: 20px">
            <div class="row">
            </div>
        </div>
        <!-- <div class="row">
            <div class="col-lg-1" style="
                         
                          top: 15%;
                        ">
                <p style="
                        writing-mode: vertical-rl;
                          text-orientation: mixed;
                          transform: rotate(180deg);
                        ">

                    {{ demochart.label }} </p>
            </div>
            <div style="margin-left: 50px" class="col-lg-4 text-center">
                <bar-chart v-if="demochart.loaded" :chart-data="demochart.chartData"
                    :extra-options="demochart.extraOptions" :height="400"></bar-chart>
            </div>
        </div> -->
        <div class="col-lg-12" style="position: relative; z-index: 999;">
            <div class="row">
                <div class="col-lg-12">
                    <card class="card-eprf">
                        <div class="col-lg-12">



                            <div class="row" style="margin-top: 10px; margin-bottom: 10px;">
                                <div class="col-lg-4">
                                    <p style="color: #358ccb; font-size: 24px; font-weight: 300">
                                        LIST OF REPORTS
                                    </p>
                                </div>
                                <div class="col-lg">
                                </div>
                                <div class="col-lg-3 text-right">
                                    <el-select placeholder="Select service location" style="width: 100%;"
                                        v-model="selects.servicelocation" filterable>
                                        <el-option v-for="option in selects.servicelocations"
                                            class="select-info custom-option" :value="option.value"
                                            :label="option.label" :key="option.value"></el-option>
                                    </el-select>
                                </div>
                                <div class="col-lg-2">
                                    <el-date-picker v-model="selects.date" type="month"
                                        style="border: 1px solid #ddd; border-bottom: 0; border-radius: 5px;"
                                        placeholder="Select Date"></el-date-picker>
                                </div>
                            </div>
                            <div id="tableku" v-if="!load">
                                <el-table :data="tableDatas" :header-cell-style="{
                                    background: 'transparent',
                                    color: 'gray',
                                }" class="custom-table" style="width: 100%; height: 800px; overflow: auto">
                                    <el-table-column :min-width="50" align="center" label="NO">
                                        <div slot-scope="scope">
                                            {{ scope.$index + 1 }}
                                        </div>
                                    </el-table-column>
                                    <el-table-column :min-width="250" align="center" prop="reportname"
                                        label="REPORT NAME">
                                        <div slot-scope="{ row }">
                                            <p style="color: gray; text-align: left;">
                                                {{ row.reportname }}
                                            </p>
                                        </div>
                                    </el-table-column>
                                    <el-table-column :min-width="200" sortable align="center" prop="lastgenerated"
                                        label="LAST GENERATED"></el-table-column>
                                    <el-table-column :min-width="100" align="center" prop="edit" label="LOG">
                                        <div slot-scope="{ row }">
                                            <i style="
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      color: gray;
                      font-size: 15px;
                      font-weight: 900;
                      cursor: pointer;
                    " @click="getReport(row.route, row.api)" class="tim-icons icon-paper"></i>
                                        </div>
                                    </el-table-column>
                                    <el-table-column :min-width="100" align="center" prop="edit">
                                        <div slot-scope="{ row }">
                                            <base-button type="primary" :disabled="cangenerate"
                                                v-on:click="generateReport(row.route, new Date(), row.api)">
                                                Generate</base-button>
                                        </div>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <div style="
                        height: 100px;
                        padding: 20px 20px 0px 20px;
                        margin: 30px 30px 0px 0px;
                      " class="d-flex justify-content-center spinner" v-if="load === true">
                                <circle-8></circle-8>
                            </div>
                        </div>
                    </card>
                </div>
            </div>
        </div>

        <!--cover untuk hide component-->
        <div
            :style="{ marginLeft: '-100px', opacity: opacityCover, position: 'absolute', zIndex: 1, top: 0, left: 0, width: '100%', height: '1250px', backgroundColor: '#F5F6FA' }">
        </div>

        <div :style="{ opacity: opacityValue[0], position: 'absolute', zIndex: 0, top: 0, left: 0, width: '100%' }"
            ref="garbageWCO" id="garbageWCO" class="row">
            <div class="row">
                <div class="col-lg-1">
                    <div class="row" style="padding: 10px; background-color: #002060;">
                        <div class="col-lg">
                            <p style="
                          color: white;
                          font-size: 21px;
                          text-align: center;
                        ">
                                Number of Trips
                            </p>
                        </div>
                    </div>

                    <div style="padding: 10px; background-color: #ED7D31;" class="row">
                        <div class="col-lg">
                            <h1 style="color: white; 
                          text-align: center;
                          font-size: 21px"> {{ garbagenooftrip }}
                            </h1>
                        </div>
                    </div>

                    <div class="row" style="margin-top: 20px; padding: 10px; background-color: #002060;">
                        <div class="col-lg">
                            <p style="
                          color: white;
                          font-size: 21px;
                          text-align: center;
                        ">
                                Total Tonnage
                            </p>
                        </div>
                    </div>

                    <div style="padding: 10px; background-color: #ED7D31;" class="row">
                        <div class="col-lg">
                            <h1 style="color: white; 
                          text-align: center;
                          font-size: 21px"> {{ garbagetotaltonnage }}
                            </h1>
                        </div>
                    </div>
                </div>
                <div class="col-lg-5">
                    <p style="
                          color: #707070;
                          font-size: 21px;
                          font-weight: bold;
                        ">
                        Total Collection Trips in {{ moment(selects.date).format("MMMM YYYY") }}
                    </p>
                    <p style="color: black; padding-left: 10px;">
                        Number of Trips</p>
                    <bar-chart v-if="garbagechart1.loaded" :chart-data="garbagechart1.chartData"
                        :extra-options="garbagechart1.extraOptions" :height="400"></bar-chart>
                    <p v-if="garbagechart1.loaded" style="color: black; text-align: center;">
                        Dates</p>
                    <div class="d-flex justify-content-center spinner" v-if="!garbagechart1.loaded">
                        <circle-8></circle-8>
                    </div>
                </div>

                <!-- <div class="col-lg-1">
                    <div class="row" style="padding-top: 40%">
                        <div class="col-lg">
                            <p style="
                          color: #707070;
                          font-size: 21px;
                          font-weight: bold;
                        ">
                                Total Cumulative
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg">
                            <h1 style="color: #3495c6; font-size: 40px">
                                {{ garbagenooftrip }}
                                <span style="color: #a8a8a8; font-size: 21px">MT</span>
                            </h1>
                        </div>
                    </div>
                </div> -->
                <div v-if="garbagechart2display" class="col-lg-6">
                    <div>
                        <pie-chart style="width: 800px;" :chart-data="garbagechart2.chartData"
                            :extra-options="garbagechart2.extraOptions">
                        </pie-chart>
                    </div>
                </div>
                <!-- <div class="col-lg-2"></div>  -->
            </div>
            <br /><br />
            <div class="row">
                <div class="col-lg-12">
                    <p style="
                          color: #707070;
                          font-size: 21px;
                          font-weight: bold;
                        ">
                        Daily Tonnage Handled by Collection Point
                    </p>
                    <!-- <p style="color: #707070;font-size: 21px;"> -->
                    <!-- Jan - Dec {{ moment(selects.date).format("YYYY") }} -->
                    <!-- </p> -->
                    <p style="color: black; padding-left: 10px;">
                        Total Tonnage (MT)</p>
                    <line-chart v-if="garbagechart3.loaded" :chart-data="garbagechart3.chartData"
                        :extra-options="garbagechart3.extraOptions" :height="400"></line-chart>
                    <p v-if="garbagechart3.loaded" style="text-align: center; color: black">
                        Dates</p>
                    <div class="d-flex justify-content-center spinner" v-if="!garbagechart3.loaded">
                        <circle-8></circle-8>
                    </div>
                </div>
                <!-- <div class="col-lg-1">
                    <div class="row" style="padding-top: 40%">
                        <div class="col-lg">
                            <p style="
                          color: #707070;
                          font-size: 21px;
                          font-weight: bold;
                        ">
                                Total Cumulative
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg">
                            <h1 style="color: #3495c6; font-size: 40px">
                                {{ totalcumulativeship }}
                                <span style="color: #a8a8a8; font-size: 21px">vessels</span>
                            </h1>
                        </div>
                    </div>
                </div> -->
                <div class="col-lg-2"></div>
            </div>

        </div>

        <div :style="{ opacity: opacityValue[1], position: 'absolute', zIndex: 0, top: 0, left: 0, width: '100%' }"
            ref="scrapWCO" id="scrapWCO" class="row">
            <div class="col-lg-9">
                <div style="border: 1px solid #eee; padding: 60px 50px 50px 50px;" class="chart-area">
                    <p style="text-align: center; color: #111; font-size: 40px">Daily Collection Tonnage for Scrap in {{
                        moment(selects.date).format("MMMM YYYY") }}</p>
                    <p style="color: black; padding-left: 10px;">
                        Quantity (MT)</p>
                    <bar-chart v-if="scrapwco.loaded" :chart-data="scrapwco.chartData"
                        :extra-options="scrapwco.extraOptions" :height="400"></bar-chart>
                    <p v-if="scrapwco.loaded" style="text-align: center; color: black">
                        Day</p>
                    <div class="d-flex justify-content-center spinner" v-if="!scrapwco.loaded">
                        <circle-8></circle-8>
                    </div>
                </div>
            </div>
            <div class="col-lg-3">
                <div class="row" style="margin-top: 100px; padding: 10px; background-color: #002060;">
                    <div class="col-lg">
                        <p style="
                          color: white;
                          font-size: 30px;
                          text-align: center;
                        ">
                            Total Scrap Collected in {{ moment(selects.date).format("MMMM YYYY") }}
                        </p>
                    </div>
                </div>

                <div style="padding: 10px; background-color: #ED7D31;" class="row">
                    <div class="col-lg">
                        <h1 style="color: white; 
                          text-align: center;
                          font-size: 110px"> {{ totalscrapwco }} MT
                        </h1>
                    </div>
                </div>
            </div>
        </div>

        <div :style="{ opacity: opacityValue[2], position: 'absolute', zIndex: 0, top: 0, left: 0, width: '100%' }"
            ref="swWCO" id="swWCO" class="row">
            <div class="col-lg-12">
                <div style="border: 1px solid #eee; padding: 10px;" class="chart-area">
                    <p style="text-align: center; color: #111; font-size: 40px">Total Collection by SW Code in {{
                        moment(selects.date).format("MMMM YYYY") }}</p>
                    <p style="color: black; padding-left: 10px;">
                        Quantity (MT)</p>
                    <div class="row">
                        <div class="col-lg">
                            <bar-chart v-if="swwco.loaded" :chart-data="swwco.chartData"
                                :extra-options="swwco.extraOptions" :height="400"></bar-chart>
                            <p v-if="swwco.loaded" style="text-align: center; color: black">
                                SW Code</p>
                            <div class="d-flex justify-content-center spinner" v-if="!swwco.loaded">
                                <circle-8></circle-8>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div :style="{ opacity: opacityValue[3], position: 'absolute', zIndex: 0, top: 0, left: 0, width: '100%' }"
            ref="tyreWCO" id="tyreWCO" class="row">
            <div class="col-lg-12">
                <div style="border: 1px solid #eee; padding: 10px;" class="chart-area">
                    <p style="text-align: center; color: #111; font-size: 40px">Tyre Collection in {{
                        moment(selects.date).format("MMMM YYYY") }}</p>
                    <div class="row">
                        <p style="color: black; padding-left: 10px;">
                            Waste Quantity (unit)</p>
                        <div class="col-lg">
                            <bar-chart v-if="tyrewco.loaded" :chart-data="tyrewco.chartData"
                                :extra-options="tyrewco.extraOptions" :height="400"></bar-chart>
                            <p v-if="tyrewco.loaded" style="text-align: center; color: black">
                                Waste Size</p>
                            <div class="d-flex justify-content-center spinner" v-if="!tyrewco.loaded">
                                <circle-8></circle-8>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div :style="{ opacity: opacityValue[4], position: 'absolute', zIndex: 0, top: 0, left: 0, width: '100%' }"
            ref="vesselGeneratedWaste" id="vesselGeneratedWaste" class="row">
            <div class="row">
                <div class="col-lg-10">
                    <p style="
                          color: #707070;
                          font-size: 21px;
                          font-weight: bold;
                        ">
                        Ship Type
                    </p>
                    <p style="color: #707070;font-size: 21px;">
                        {{ moment(selects.date).format("MMM YYYY") }}
                    </p>
                    <line-chart v-if="vesselchart1.loaded" :chart-data="vesselchart1.chartData"
                        :extra-options="vesselchart1.extraOptions" :height="400"></line-chart>
                    <div class="d-flex justify-content-center spinner" v-if="!vesselchart1.loaded">
                        <circle-8></circle-8>
                    </div>
                </div>
                <div class="col-lg-1">
                    <div class="row" style="padding-top: 40%">
                        <div class="col-lg">
                            <p style="
                          color: #707070;
                          font-size: 21px;
                          font-weight: bold;
                        ">
                                Total Cumulative
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg">
                            <h1 style="color: #3495c6; font-size: 40px">
                                {{ totalcumulativeship }}
                                <span style="color: #a8a8a8; font-size: 21px">vessels</span>
                            </h1>
                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
            <br /><br />
            <div class="row">
                <div class="col-lg-3" style="
                          position: absolute;
                          writing-mode: vertical-rl;
                          text-orientation: mixed;
                          transform: rotate(180deg);
                          top: 15%;
                        ">
                    {{ demochart.label }}
                </div>
                <div class="col-lg-5">
                    <p style="
                          color: #707070;
                          font-size: 21px;
                          font-weight: bold;
                        ">
                        Volume of Discharged
                    </p>
                    <bar-chart v-if="vesselchart2.loaded" :chart-data="vesselchart2.chartData"
                        :extra-options="vesselchart2.extraOptions" :height="400"></bar-chart>
                    <div class="d-flex justify-content-center spinner" v-if="!vesselchart2.loaded">
                        <circle-8></circle-8>
                    </div>
                </div>
                <div class="col-lg-1">
                    <div class="row" style="padding-top: 40%">
                        <div class="col-lg">
                            <p style="
                          color: #707070;
                          font-size: 21px;
                          font-weight: bold;
                        ">
                                Total Cumulative
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg">
                            <h1 style="color: #3495c6; font-size: 40px">
                                {{ totalvolumedischarged }}
                                <span style="color: #a8a8a8; font-size: 21px">MT</span>
                            </h1>
                        </div>
                    </div>
                </div>
                <div v-if="vesselchart3display" class="col-lg-6">
                    <div>
                        <pie-chart style="margin-left: -500px;" :chart-data="vesselchart3.chartData"
                            :extra-options="vesselchart3.extraOptions" :height="250">
                        </pie-chart>
                    </div>
                </div>
            </div>
        </div>

        <div :style="{ opacity: opacityValue[5], position: 'absolute', zIndex: 0, top: 0, left: 0, width: '100%' }"
            ref="wcoOverall" id="wcoOverall" class="row">
            <div v-if="wcooveralldisplay" class="col-lg-12">
                <p style="margin-left: -350px; font-size: 40px; color: #686868; text-align: center;">
                    Number of WCO in {{ moment(selects.date).format("MMMM YYYY") }}
                </p>
                <div style="margin-left: -340px;">
                    <pie-chart :chart-data="wcooverall.chartData" :extra-options="wcooverall.extraOptions"
                        :height="400">
                    </pie-chart>
                    <!-- <pie-chart v-if="wcooverall.loaded" :chart-data="wcooverall.chartData"
                        :extra-options="wcooverall.extraOptions" :height="250"></pie-chart>
                    <div class="d-flex justify-content-center spinner" v-if="!wcooverall.loaded">
                        <circle-8></circle-8>
                    </div> -->
                </div>
            </div>
        </div>

        <div :style="{ opacity: opacityValue[6], position: 'absolute', zIndex: 0, top: 0, left: 0, width: '100%' }"
            ref="wdo" id="wdo" class="row">
            <div class="col-lg-3"></div>
            <div style="border: 1px solid #eee; padding: 60px 50px 50px 50px;" class="col-lg-5">
                <p style="font-size: 40px; color: #686868; text-align: center;">
                    Number of WDO in {{ moment(selects.date).format("MMMM YYYY") }}
                </p>
                <div>
                    <pie-chart :chart-data="wdochart.chartData" :extra-options="wdochart.extraOptions" :height="400">
                    </pie-chart>
                </div>
            </div>
        </div>

        <div :style="{ opacity: opacityValue[7], position: 'absolute', zIndex: 0, top: 0, left: 0, width: '100%' }"
            ref="wdr" id="wdr">
            <div class="row">
                <div class="col-lg-1"></div>
                <div v-if="wdrchart1display"
                    style="margin-right: 10px; border: 1px solid #eee; padding: 60px 50px 50px 50px;" class="col-lg-4">
                    <p style="font-size: 40px; color: #111; text-align: center;">
                        Total Number of WDR
                    </p>
                    <p style="font-size: 40px; color: #111; text-align: center;">
                        in {{ moment(selects.date).format("MMMM YYYY") }}
                    </p>
                    <div>
                        <pie-chart :chart-data="wdrchart1.chartData" :extra-options="wdrchart1.extraOptions"
                            :height="400">
                        </pie-chart>
                    </div>
                </div>
                <div v-if="wdrchart2display"
                    style="margin-left: 10px; border: 1px solid #eee; padding: 60px 50px 50px 50px;" class="col-lg-4">
                    <p style="font-size: 40px; color: #111; text-align: center;">
                        Total Tonnage Discharged
                    </p>
                    <p style="font-size: 40px; color: #111; text-align: center;">
                        in {{ moment(selects.date).format("MMMM YYYY") }}
                    </p>
                    <div>
                        <pie-chart :chart-data="wdrchart2.chartData" :extra-options="wdrchart2.extraOptions"
                            :height="400">
                        </pie-chart>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
            <br />
            <div class="row">
                <div class="col-lg-2"></div>
                <div class="col-lg-6">
                    <div style="border: 1px solid #eee; padding: 60px 50px 50px 50px;" class="chart-area">
                        <p style="text-align: center; color: #111; font-size: 40px">Number of WDR against Tonnage
                            Discharge</p>
                        <p style="color: black; padding-left: 10px;">
                            Total Tonnage (MT)</p>
                        <bar-chart v-if="wdrchart3.loaded" :chart-data="wdrchart3.chartData"
                            :extra-options="wdrchart3.extraOptions" :height="400"></bar-chart>
                        <p v-if="wdrchart3.loaded" style="text-align: center; color: black">
                            MARPOL Annexes</p>
                        <div class="d-flex justify-content-center spinner" v-if="!wdrchart3.loaded">
                            <circle-8></circle-8>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import moment from "moment";
import {
    Alert,
    Select,
    Option,
    DatePicker,
    Table,
    TableColumn,
} from "element-ui";
import swal from "sweetalert2";
import { Circle8 } from "vue-loading-spinner";
import Card from "../../../components/Cards/Card.vue";
import GarbageWCO from "../Admin/Report/GarbageWCO.vue"
import RevenueSharing from "../Admin/Report/RevenueSharing.vue"
import ScrapWCO from "../Admin/Report/ScrapWCO.vue"
import SWWCO from "../Admin/Report/SWWCO.vue"
import TyreWCO from "../Admin/Report/TyreWCO.vue"
import VesselGeneratedWaste from "../Admin/Report/VesselGeneratedWaste.vue"
import VesselsBerthVolume from "../Admin/Report/VesselsBerthVolume.vue"
import WCOOverall from "../Admin/Report/WCOOverall.vue"
import WDO from "../Admin/Report/WDO.vue"
import WDR from "../Admin/Report/WDR.vue"
import LineChart from "@/components/Charts/LineChart";
import PieChart from "src/components/Charts/PieChart";
import * as chartConfigs from "@/components/Charts/config";
import BarChart from "src/components/Charts/BarChart";
import config from "@/config";
import Loading from "vue-loading-overlay";

export default {
    name: "Reports",

    components: {
        Card,
        [Select.name]: Select,
        [Option.name]: Option,
        [DatePicker.name]: DatePicker,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        Circle8,
        GarbageWCO,
        RevenueSharing,
        ScrapWCO,
        SWWCO,
        TyreWCO,
        VesselGeneratedWaste,
        VesselsBerthVolume,
        WCOOverall,
        WDO,
        WDR,
        Circle8,
        PieChart,
        BarChart,
        LineChart,
        Loading,
    },

    data() {
        return {
            isLoading: false,
            opacityValue: [0, 0, 0, 0, 0, 0, 0, 0],
            opacityCover: 0,
            shiptype: {
                chartData: {
                    labels: [],
                    datasets: [
                        {
                            yAxisID: "y-axis-1",
                            type: "line",
                            label: "Vessel Generated",
                            fill: false,
                            borderColor: "#32BA7C",
                            borderWidth: 2,
                            borderDash: [],
                            borderDashOffset: 0.5,
                            pointBackgroundColor: "#32BA7C",
                            pointBorderColor: "rgba(255,255,255,0)",
                            pointHoverBackgroundColor: "#32BA7C",
                            pointBorderWidth: 20,
                            pointHoverRadius: 4,
                            pointHoverBorderWidth: 15,
                            pointRadius: 4,
                            data: [1, 2, 3, 4, 5, 6],
                        },
                        {
                            yAxisID: "y-axis-2",
                            type: "line",
                            label: "Land Generated",
                            fill: false,
                            borderColor: "#358CCB",
                            borderWidth: 2,
                            borderDash: [],
                            borderDashOffset: 0.0,
                            pointBackgroundColor: "#358CCB",
                            pointBorderColor: "rgba(255,255,255,0)",
                            pointHoverBackgroundColor: "#358CCB",
                            pointBorderWidth: 20,
                            pointHoverRadius: 4,
                            pointHoverBorderWidth: 15,
                            pointRadius: 4,
                            data: [],
                        },
                    ],
                },
                loaded: true,
                extraOptions: chartConfigs.purpleChartOptionslll,
                gradientColors: config.colors.primaryGradient,
                gradientStops: [1, 1, 1],
            },

            totalscrapwco: 0,
            scrapwco: {
                chartData: {
                    labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
                    datasets: [
                        {
                            label: "Data",
                            fill: true,
                            barPercentage: 0.1,
                            borderRadius: 100,
                            //  pointStyle: 'circle',
                            backgroundColor: "rgba(52,149,198,0.9)",
                            // borderColor: config.colors.danger,
                            // borderWidth: 0,
                            // borderDash: [],
                            // borderDashOffset: 0.5,
                            data: [80, 100, 70, 80, 120, 80],
                        },
                    ],
                },
                loaded: false,
                extraOptions: chartConfigs.barChartOptionsGradient2,
                gradientColors: config.colors.purpleGradient,
                gradientStops: [1, 0],
            },

            totalswwco: 0,
            swwco: {
                chartData: {
                    labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
                    datasets: [
                        {
                            label: "Data",
                            fill: true,
                            barPercentage: 0.1,
                            borderRadius: 100,
                            //  pointStyle: 'circle',
                            backgroundColor: "rgba(52,149,198,0.9)",
                            // borderColor: config.colors.danger,
                            // borderWidth: 0,
                            // borderDash: [],
                            // borderDashOffset: 0.5,
                            data: [80, 100, 70, 80, 120, 80],
                        },
                    ],
                },
                loaded: false,
                extraOptions: chartConfigs.barChartOptionsGradient2,
                gradientColors: config.colors.purpleGradient,
                gradientStops: [1, 0],
            },

            totaltyrewco: 0,
            tyrewco: {
                chartData: {
                    labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
                    datasets: [
                        {
                            label: "Data",
                            fill: true,
                            barPercentage: 0.1,
                            borderRadius: 100,
                            //  pointStyle: 'circle',
                            backgroundColor: "rgba(52,149,198,0.9)",
                            // borderColor: config.colors.danger,
                            // borderWidth: 0,
                            // borderDash: [],
                            // borderDashOffset: 0.5,
                            data: [80, 100, 70, 80, 120, 80],
                        },
                    ],
                },
                loaded: false,
                extraOptions: chartConfigs.barChartOptionsGradient2,
                gradientColors: config.colors.purpleGradient,
                gradientStops: [1, 0],
            },

            pieChart2: {
                chartData: {
                    labels: [1, 2, 3],
                    datasets: [
                        {
                            label: 'Emails',
                            pointRadius: 0,
                            pointHoverRadius: 0,
                            backgroundColor: ['#ff8779', '#2a84e9', '#e2e2e2'],
                            borderWidth: 0,
                            data: [60, 40, 20]
                        }
                    ]
                },
                extraOptions: chartConfigs.pieChartOptions15
            },

            wdochartdisplay: true,

            wdochart1: {
                chartData: {
                    labels: [1, 2, 3],
                    datasets: [
                        {
                            label: 'Emails',
                            pointRadius: 0,
                            pointHoverRadius: 0,
                            backgroundColor: ['#4472C4', '#ED7D31', '#A5A5A5', '#FFC102', '#5B9BD5'],
                            borderWidth: 0,
                            data: [60, 40, 20]
                        }
                    ]
                },
                extraOptions: chartConfigs.pieChartOptions15
            },

            vesselchart3display: true,

            vesselchart1: {
                chartData: {
                    labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
                    datasets: [
                        {
                            label: "Data",
                            fill: true,
                            barPercentage: 0.1,
                            borderRadius: 100,
                            //  pointStyle: 'circle',
                            backgroundColor: "rgba(52,149,198,0.9)",
                            // borderColor: config.colors.danger,
                            // borderWidth: 0,
                            // borderDash: [],
                            // borderDashOffset: 0.5,
                            data: [80, 100, 70, 80, 120, 80],
                        },
                    ],
                },
                loaded: false,
                extraOptions: chartConfigs.barChartOptionsGradient2,
                gradientColors: config.colors.purpleGradient,
                gradientStops: [1, 0],
            },

            vesselchart2: {
                chartData: {
                    labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
                    datasets: [
                        {
                            label: "Data",
                            fill: true,
                            barPercentage: 0.1,
                            borderRadius: 100,
                            //  pointStyle: 'circle',
                            backgroundColor: "rgba(52,149,198,0.9)",
                            // borderColor: config.colors.danger,
                            // borderWidth: 0,
                            // borderDash: [],
                            // borderDashOffset: 0.5,
                            data: [80, 100, 70, 80, 120, 80],
                        },
                    ],
                },
                loaded: false,
                extraOptions: chartConfigs.barChartOptionsGradient2,
                gradientColors: config.colors.purpleGradient,
                gradientStops: [1, 0],
            },

            vesselchart3: {
                chartData: {
                    labels: [1, 2, 3],
                    datasets: [
                        {
                            label: 'Emails',
                            pointRadius: 0,
                            pointHoverRadius: 0,
                            backgroundColor: ['#3495C6', '#33BBB7', '#3BA335', '#C1C1C1', '#EBEBEB'],
                            borderWidth: 0,
                            data: [60, 40, 20]
                        }
                    ]
                },
                extraOptions: chartConfigs.pieChartOptions15
            },

            garbagenooftrip: 0,
            garbagetotaltonnage: 0,

            demochart: {
                label: '',
                chartData: {
                    labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
                    datasets: [
                        {
                            label: "Data",
                            fill: true,
                            barPercentage: 0.1,
                            borderRadius: 100,
                            backgroundColor: "rgba(52,149,198,0.9)",
                            data: [80, 100, 70, 80, 120, 80],
                        },
                    ],
                },
                loaded: true,
                extraOptions: chartConfigs.barChartOptionsGradient2,
                gradientColors: config.colors.purpleGradient,
                gradientStops: [1, 0],
            },

            //barchart
            garbagechart1: {
                chartData: {
                    labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
                    datasets: [
                        {
                            label: "Data",
                            fill: true,
                            barPercentage: 0.1,
                            borderRadius: 100,
                            //  pointStyle: 'circle',
                            backgroundColor: "rgba(52,149,198,0.9)",
                            // borderColor: config.colors.danger,
                            // borderWidth: 0,
                            // borderDash: [],
                            // borderDashOffset: 0.5,
                            data: [80, 100, 70, 80, 120, 80],
                        },
                    ],
                },
                loaded: false,
                extraOptions: chartConfigs.barChartOptionsGradient2,
                gradientColors: config.colors.purpleGradient,
                gradientStops: [1, 0],
            },

            garbagechart2display: true,

            //piechart
            garbagechart2: {
                chartData: {
                    labels: [1, 2, 3],
                    datasets: [
                        {
                            label: 'Emails',
                            pointRadius: 0,
                            pointHoverRadius: 0,
                            backgroundColor: ['#7FB65B', '#264478', '#4472C4', '#ED7D31', '#A5A5A5', '#FFC102', '#5B9BD5'],
                            borderWidth: 0,
                            data: [60, 40, 20]
                        }
                    ]
                },
                extraOptions: chartConfigs.pieChartOptions15
            },

            //linechart
            garbagechart3: {
                chartData: {
                    labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
                    datasets: [
                        {
                            label: "Data",
                            fill: true,
                            barPercentage: 0.1,
                            borderRadius: 100,
                            //  pointStyle: 'circle',
                            backgroundColor: "rgba(52,149,198,0.9)",
                            // borderColor: config.colors.danger,
                            // borderWidth: 0,
                            // borderDash: [],
                            // borderDashOffset: 0.5,
                            data: [80, 100, 70, 80, 120, 80],
                        },
                    ],
                },
                loaded: false,
                extraOptions: chartConfigs.barChartOptionsGradient2,
                gradientColors: config.colors.purpleGradient,
                gradientStops: [1, 0],
            },

            wcochartdisplay: true,
            wcochart: {
                chartData: {
                    labels: [1, 2, 3],
                    datasets: [
                        {
                            label: 'Emails',
                            pointRadius: 0,
                            pointHoverRadius: 0,
                            backgroundColor: ['#3495C6', '#33BBB7', '#3BA335', '#C1C1C1', '#EBEBEB'],
                            borderWidth: 0,
                            data: [60, 40, 20]
                        }
                    ]
                },
                extraOptions: chartConfigs.pieChartOptions15
            },

            wdrchart1display: true,
            wdrchart2display: true,

            wdrchart1: {
                chartData: {
                    labels: [1, 2, 3],
                    datasets: [
                        {
                            label: 'Emails',
                            pointRadius: 0,
                            pointHoverRadius: 0,
                            backgroundColor: ['#4472C4', '#ED7D31', '#A5A5A5', '#FFC102', '#5B9BD5'],
                            borderWidth: 0,
                            data: [60, 40, 20]
                        }
                    ]
                },
                extraOptions: chartConfigs.pieChartOptions15
            },

            wdrchart2: {
                chartData: {
                    labels: [1, 2, 3],
                    datasets: [
                        {
                            label: 'Emails',
                            pointRadius: 0,
                            pointHoverRadius: 0,
                            backgroundColor: ['#4472C4', '#ED7D31', '#A5A5A5', '#FFC102', '#5B9BD5'],
                            borderWidth: 0,
                            data: [60, 40, 20]
                        }
                    ]
                },
                extraOptions: chartConfigs.pieChartOptions15
            },

            wdrchart3: {
                chartData: {
                    labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
                    datasets: [
                        {
                            label: "Data",
                            fill: true,
                            barPercentage: 0.1,
                            borderRadius: 100,
                            //  pointStyle: 'circle',
                            backgroundColor: "rgba(52,149,198,0.9)",
                            // borderColor: config.colors.danger,
                            // borderWidth: 0,
                            // borderDash: [],
                            // borderDashOffset: 0.5,
                            data: [80, 100, 70, 80, 120, 80],
                        },
                        {
                            type: "line",
                            label: "Schedule",
                            fill: false,
                            borderColor: "rgba(237, 28, 36, 1)",
                            borderWidth: 2,
                            borderDash: [],
                            borderDashOffset: 0.0,
                            pointBackgroundColor: "rgba(237, 28, 36, 1)",
                            pointBorderColor: "rgba(255,255,255,0)",
                            pointHoverBackgroundColor: config.colors.danger,
                            pointBorderWidth: 20,
                            pointHoverRadius: 4,
                            pointHoverBorderWidth: 15,
                            pointRadius: 4,
                            data: [180, 10, 40, 20, 10, 180],

                        },
                    ],
                },
                loaded: false,
                extraOptions: chartConfigs.barChartOptionsGradient2,
                gradientColors: config.colors.purpleGradient,
                gradientStops: [1, 0],
            },

            wcooveralldisplay: true,
            wcooverall: {
                chartData: {
                    labels: [1, 2, 3],
                    datasets: [
                        {
                            label: 'Emails',
                            pointRadius: 0,
                            pointHoverRadius: 0,
                            backgroundColor: ['#4472C4', '#ED7D31', '#A5A5A5', '#FFC102', '#5B9BD5'],
                            borderWidth: 0,
                            data: [60, 40, 20]
                        }
                    ]
                },
                extraOptions: chartConfigs.pieChartOptions15
            },

            wdochart: {
                chartData: {
                    labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
                    datasets: [
                        {
                            label: "Data",
                            fill: true,
                            barPercentage: 0.1,
                            borderRadius: 100,
                            //  pointStyle: 'circle',
                            backgroundColor: "rgba(52,149,198,0.9)",
                            // borderColor: config.colors.danger,
                            // borderWidth: 0,
                            // borderDash: [],
                            // borderDashOffset: 0.5,
                            data: [80, 100, 70, 80, 120, 80],
                        },
                    ],
                },
                loaded: false,
                extraOptions: chartConfigs.barChartOptionsGradient2,
                gradientColors: config.colors.purpleGradient,
                gradientStops: [1, 0],
            },

            totalvolumedischarged: '',
            totalcumulativeship: '',
            totalcumulative: "",
            totalcumulativevolume: "",
            garbageWCO: null,
            revenueSharing: null,
            scrapWCO: null,
            swWCO: null,
            tyreWCO: null,
            vesselGeneratedWaste: null,
            vesselsBerthVolume: null,
            wcoOverall: null,
            wdo: null,
            wdr: null,
            load: false,
            tableDatas: [
                {
                    reportname: 'Vessel Generated Waste',
                    lastgenerated: '09/12/2024 14:12',
                    route: 'VesselGeneratedWaste',
                    api: '',
                },
                {
                    reportname: 'Waste Collection Order (Garbage)',
                    lastgenerated: '09/12/2024 14:12',
                    route: 'GarbageWCO',
                    api: '',
                },
                {
                    reportname: 'Waste Collection Order (Scrap)',
                    lastgenerated: '09/12/2024 14:12',
                    route: 'ScrapWCO',
                    api: '',
                },
                {
                    reportname: 'Waste Collection Order (Scheduled Waste & Washwater)',
                    lastgenerated: '09/12/2024 14:12',
                    route: 'SWWCO',
                    api: '',
                },
                {
                    reportname: 'Waste Collection Order (Tyre)',
                    lastgenerated: '09/12/2024 14:12',
                    route: 'TyreWCO',
                    api: '',
                },
                {
                    reportname: 'Waste Delivery Order',
                    lastgenerated: '09/12/2024 14:12',
                    route: 'WDO',
                    api: '',
                },
                {
                    reportname: 'Waste Delivery Receipt',
                    lastgenerated: '09/12/2024 14:12',
                    route: 'WDR',
                    api: '',
                },
                {
                    reportname: 'Waste Collection Order (Overall)',
                    lastgenerated: '09/12/2024 14:12',
                    route: 'WCOOverall',
                    api: '',
                },
                {
                    reportname: 'Vessels Berth and Volume',
                    lastgenerated: '09/12/2024 14:12',
                    route: 'VesselsBerthVolume',
                    api: '',
                },
                {
                    reportname: 'Revenue Sharing',
                    lastgenerated: '09/12/2024 14:12',
                    route: 'RevenueSharing',
                    api: '',
                },
            ],
            selects: {
                assigner: "",
                assigners: [
                    { value: "00", label: "All" },
                    { value: "01", label: "Yahya Abd Rahman" },
                    { value: "02", label: "Ikhwan Ayub" },
                    { value: "03", label: "Haziq Haikal" },
                ],
                date: "",
                dates: [],
                type: "",
                quostatus: "",
                quostatuses: [],
                servicelocation: "",
                servicelocations: [],
            },
        };
    },
    methods: {
        async generateReport(route, generatedtime, api) {
            const startdate = moment(new Date(this.selects.date.getFullYear(), this.selects.date.getMonth(), 1)).format("YYYY-MM-DD");
            const enddate = moment(new Date(this.selects.date.getFullYear(), this.selects.date.getMonth() + 1, 0)).format("YYYY-MM-DD");;
            console.log('date range ' + startdate.toString() + " " + enddate.toString());

            if (route == 'GarbageWCO') {
                let formatter = new Intl.NumberFormat("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });

                this.garbagechart1 = false;
                this.garbagechart2 = false;
                this.garbagechart3 = false;

                let bardata = [];
                let barlabel = [];

                let ndsb = [];
                let drybulkterminal = [];
                let yardstore2 = [];
                let osc = [];
                let godownb2 = [];
                let godowne1 = [];
                let northportc = [];

                let bardata2 = [];
                let barlabel2 = [];

                let bardata3 = [];
                let barlabel3 = [];

                // await this.$http.get("/api/v1/report/monthly_list_of_garbage?start_date=2024-01-01&end_date=2024-12-31&service_location_id").then((res) => {
                await this.$http.get(":10001/api/v1/report/monthly_list_of_garbage?start_date=" + startdate + "&end_date=" + enddate + "&service_location_id=" + this.selects.servicelocation).then((res) => {
                    if (!res.error) {
                        let response = res.message;

                        let total = 0;

                        if (response.LineGraph !== null) {
                            // for (var i = 0; i < response.ShipType.length; i++) {
                            //     total += response.ShipType[i].TotalCumulative;
                            //     // bardata.push(response.JobData.Value[i]);
                            //     // barlabel.push(response.JobData.Label[i]);
                            // }

                            for (var i = 0; i < response.LineGraph[1].Label.length; i++) {
                                ndsb.push(response.LineGraph[0].Value[i]);
                                drybulkterminal.push(response.LineGraph[1].Value[i]);
                                yardstore2.push(response.LineGraph[2].Value[i]);
                                osc.push(response.LineGraph[3].Value[i]);
                                godownb2.push(response.LineGraph[4].Value[i]);
                                godowne1.push(response.LineGraph[5].Value[i]);
                                northportc.push(response.LineGraph[6].Value[i]);
                                barlabel3.push(response.LineGraph[0].Label[i]);
                            }

                            this.totalcumulativeship = formatter.format(total).toString();
                        }

                        if (response.VolumeDischarge !== null) {
                            for (var i = 0; i < response.MonthlyCollectionTrip.Label.length; i++) {
                                bardata.push(response.MonthlyCollectionTrip.Value[i]);
                                barlabel.push(response.MonthlyCollectionTrip.Label[i]);
                            }
                            // console.log('wht', response.VolumeDischarge.TotalCumulative);
                            this.garbagenooftrip = response.NumberOfTrip.toString();
                        }

                        if (response.PieChart !== null)
                            for (var i = 0; i < response.PieChart.Label.length; i++) {
                                bardata2.push(response.PieChart.Value[i]);
                                barlabel2.push(`${response.PieChart.Label[i]} (${response.PieChart.Value[i]})`);
                            }
                        else
                            this.garbagechart2display = false;
                    }
                });

                this.garbagechart3 = {
                    chartData: {
                        labels: barlabel3,
                        datasets: [
                            {
                                yAxisID: "y-axis-1",
                                type: "line",
                                label: "NDSB",
                                fill: false,
                                borderColor: "#7ED3D0",
                                borderWidth: 2,
                                borderDash: [],
                                borderDashOffset: 0.0,
                                pointBackgroundColor: "#7ED3D0",
                                pointBorderColor: "rgba(255,255,255,0)",
                                pointHoverBackgroundColor: "#7ED3D0",
                                pointBorderWidth: 20,
                                pointHoverRadius: 4,
                                pointHoverBorderWidth: 15,
                                pointRadius: 4,
                                data: ndsb,
                            },
                            {
                                yAxisID: "y-axis-2",
                                type: "line",
                                label: "Dry Bulk Terminal",
                                fill: false,
                                borderColor: "#247BB5",
                                borderWidth: 2,
                                borderDash: [],
                                borderDashOffset: 0.0,
                                pointBackgroundColor: "#247BB5",
                                pointBorderColor: "rgba(255,255,255,0)",
                                pointHoverBackgroundColor: "#247BB5",
                                pointBorderWidth: 20,
                                pointHoverRadius: 4,
                                pointHoverBorderWidth: 15,
                                pointRadius: 4,
                                data: drybulkterminal,
                            },
                            {
                                yAxisID: "y-axis-2",
                                type: "line",
                                label: "Yard Store2",
                                fill: false,
                                borderColor: "#A8CFE3",
                                borderWidth: 2,
                                borderDash: [],
                                borderDashOffset: 0.0,
                                pointBackgroundColor: "#A8CFE3",
                                pointBorderColor: "rgba(255,255,255,0)",
                                pointHoverBackgroundColor: "#A8CFE3",
                                pointBorderWidth: 20,
                                pointHoverRadius: 4,
                                pointHoverBorderWidth: 15,
                                pointRadius: 4,
                                data: yardstore2,
                            },
                            {
                                yAxisID: "y-axis-2",
                                type: "line",
                                label: "OSC",
                                fill: false,
                                borderColor: "#B2DF8A",
                                borderWidth: 2,
                                borderDash: [],
                                borderDashOffset: 0.0,
                                pointBackgroundColor: "#B2DF8A",
                                pointBorderColor: "rgba(255,255,255,0)",
                                pointHoverBackgroundColor: "#B2DF8A",
                                pointBorderWidth: 20,
                                pointHoverRadius: 4,
                                pointHoverBorderWidth: 15,
                                pointRadius: 4,
                                data: osc,
                            },
                            {
                                yAxisID: "y-axis-2",
                                type: "line",
                                label: "Godown B2",
                                fill: false,
                                borderColor: "#FDC884",
                                borderWidth: 2,
                                borderDash: [],
                                borderDashOffset: 0.0,
                                pointBackgroundColor: "#FDC884",
                                pointBorderColor: "rgba(255,255,255,0)",
                                pointHoverBackgroundColor: "#FDC884",
                                pointBorderWidth: 20,
                                pointHoverRadius: 4,
                                pointHoverBorderWidth: 15,
                                pointRadius: 4,
                                data: godownb2,
                            },
                            {
                                yAxisID: "y-axis-2",
                                type: "line",
                                label: "Godown E1",
                                fill: false,
                                borderColor: "#DADADA",
                                borderWidth: 2,
                                borderDash: [],
                                borderDashOffset: 0.0,
                                pointBackgroundColor: "#DADADA",
                                pointBorderColor: "rgba(255,255,255,0)",
                                pointHoverBackgroundColor: "#DADADA",
                                pointBorderWidth: 20,
                                pointHoverRadius: 4,
                                pointHoverBorderWidth: 15,
                                pointRadius: 4,
                                data: godowne1,
                            },
                            {
                                yAxisID: "y-axis-2",
                                type: "line",
                                label: "Northport C",
                                fill: false,
                                borderColor: "#87C683",
                                borderWidth: 2,
                                borderDash: [],
                                borderDashOffset: 0.0,
                                pointBackgroundColor: "#87C683",
                                pointBorderColor: "rgba(255,255,255,0)",
                                pointHoverBackgroundColor: "#87C683",
                                pointBorderWidth: 20,
                                pointHoverRadius: 4,
                                pointHoverBorderWidth: 15,
                                pointRadius: 4,
                                data: northportc,
                            },
                        ],
                    },
                    loaded: true,

                    extraOptions: chartConfigs.purpleChartOptionsllls,
                    gradientColors: config.colors.primaryGradient,
                    gradientStops: [1, 1, 1],
                };

                this.garbagechart2 = {
                    chartData: {
                        labels: barlabel2,
                        datasets: [
                            {
                                label: 'Emails',
                                pointRadius: 0,
                                pointHoverRadius: 0,
                                backgroundColor: ['#7FB65B', '#264478', '#4472C4', '#ED7D31', '#A5A5A5', '#FFC102', '#5B9BD5'],
                                borderWidth: 0,
                                data: bardata2,
                            }
                        ]
                    },
                    extraOptions: {
                        maintainAspectRatio: false,
                        legend: {
                            display: true,
                            position: "left",
                            labels: {
                                usePointStyle: true,
                                pointStyle: {
                                    margin: "10px",
                                },
                                boxWidth: 10,
                                fontColor: "gray",
                            },
                        },
                        elements: {
                            center: {
                                text: "",
                                //   color: "#000000", // Default is #000000
                                fontStyle: "Poppins", // Default is Arial
                                sidePadding: 20, // Default is 20 (as a percentage)
                                minFontSize: 20, // Default is 20 (in px), set to false and text will not wrap.
                                lineHeight: 30, // Default is 25 (in px), used for when text wraps
                            },
                        },
                        responsive: true,
                        cutoutPercentage: 80,
                        tooltips: {
                            backgroundColor: "#f5f5f5",
                            titleFontColor: "#333",
                            bodyFontColor: "#666",
                            bodySpacing: 4,
                            xPadding: 12,
                            mode: "nearest",
                            intersect: 0,
                            position: "nearest",
                        },
                        animation: {
                            duration: 500,
                            onComplete: function (chart) {
                                if (chart.chart.config.options.elements.center) {
                                    // Get ctx from string
                                    var ctx = chart.chart.ctx;

                                    ctx.textAlign = "center";
                                    ctx.textBaseline = "middle";
                                    var centerX =
                                        (chart.chart.chartArea.left + chart.chart.chartArea.right) /
                                        2;
                                    var centerY =
                                        (chart.chart.chartArea.top + chart.chart.chartArea.bottom) /
                                        2;

                                    //Draw text in center
                                    ctx.font = " 20px Poppins, sans-serif";
                                    ctx.fillStyle = "#000000";
                                    ctx.fillText("", centerX, centerY - 10);
                                    ctx.fillText("", centerX, centerY + 15);
                                }
                            },
                        },

                        scales: {
                            yAxes: [
                                {
                                    display: 0,
                                    ticks: {
                                        display: false,
                                    },
                                    gridLines: {
                                        drawBorder: false,
                                        zeroLineColor: "transparent",
                                        color: "rgba(255,255,255,0.05)",
                                    },
                                },
                            ],

                            xAxes: [
                                {
                                    display: 0,
                                    barPercentage: 1.6,
                                    gridLines: {
                                        drawBorder: false,
                                        color: "rgba(255,255,255,0.1)",
                                        zeroLineColor: "transparent",
                                    },
                                    ticks: {
                                        display: false,
                                    },
                                },
                            ],
                        },
                    },
                    // extraOptions: chartConfigs.pieChartOptions15
                };

                this.garbagechart1 = {
                    chartData: {
                        labels: barlabel,
                        datasets: [
                            {
                                label: "Total Trip",
                                barPercentage: 0.3,
                                borderRadius: 10,
                                borderWidth: 0.3,
                                radius: 5,

                                fill: true,
                                backgroundColor: (ctx) => {
                                    const canvas = ctx.chart.ctx;
                                    const gradient = canvas.createLinearGradient(
                                        0,
                                        0,
                                        0,
                                        160
                                    );

                                    gradient.addColorStop(0, "#ED7D31");
                                    gradient.addColorStop(1, "#ED7D31");

                                    return gradient;
                                },
                                tension: 0.25,
                                data: bardata,
                            },
                        ],
                    },
                    loaded: true,
                    extraOptions: chartConfigs.barChartOptionsGradient3,
                    gradientColors: config.colors.purpleGradient,
                    gradientStops: [1, 0],
                };

                this.opacityCover = 1;
                this.opacityValue[0] = 1;
                this.isLoading = true;
                if (this.garbageWCO) {
                    await this.$nextTick();
                    await new Promise(resolve => setTimeout(resolve, 500));

                    await this.garbageWCO.getDownload(
                        this.$refs.garbageWCO,
                        moment(generatedtime).format("DD MMMM YYYY, hh:mm A"),
                        this.selects.servicelocation,
                        startdate.toString(),
                        enddate.toString(),
                        api
                    );
                    this.getData();
                    this.opacityValue[0] = 0;
                    this.opacityCover = 0;
                    this.isLoading = false;
                }
            } else if (route == 'RevenueSharing') {
                this.isLoading = true;
                if (this.revenueSharing) {
                    this.revenueSharing.getDownload(
                        moment(generatedtime).format("DD MMMM YYYY, hh:mm A"),
                        this.selects.servicelocation,
                        startdate.toString(),
                        enddate.toString(),
                        api
                    );
                    this.getData();
                    this.isLoading = false;
                }
            } else if (route == 'ScrapWCO') {
                let formatter = new Intl.NumberFormat("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });

                this.scrapwco = false;

                let bardata = [];
                let barlabel = [];

                // await this.$http.get(":10001/api/v1/report/monthly_scrap_collection?start_date=2024-01-01&end_date=2024-12-31&service_location_id").then((res) => {
                await this.$http.get(":10001/api/v1/report/monthly_scrap_collection?start_date=" + startdate + "&end_date=" + enddate + "&service_location_id=" + this.selects.servicelocation).then((res) => {
                    if (!res.error) {
                        let response = res.message;

                        if (response.BarGraph !== null) {
                            console.log("ni scrap", response.BarGraph);
                            for (var i = 0; i < response.BarGraph.Label.length; i++) {
                                bardata.push(response.BarGraph.Value[i]);
                                barlabel.push(response.BarGraph.Label[i]);
                            }
                        }

                        this.totalscrapwco = formatter.format(response.Total);
                    }
                });

                this.scrapwco = {
                    chartData: {
                        labels: barlabel,
                        datasets: [
                            {
                                label: "Qty (MT)",
                                barPercentage: 0.3,
                                borderRadius: 10,
                                borderWidth: 0.3,
                                radius: 5,

                                fill: true,
                                backgroundColor: (ctx) => {
                                    const canvas = ctx.chart.ctx;
                                    const gradient = canvas.createLinearGradient(
                                        0,
                                        0,
                                        0,
                                        160
                                    );

                                    gradient.addColorStop(0, "#ED7D31");
                                    gradient.addColorStop(1, "#ED7D31");

                                    return gradient;
                                },
                                tension: 0.25,
                                data: bardata,
                            },
                        ],
                    },
                    loaded: true,
                    extraOptions: chartConfigs.barChartOptionsGradient3,
                    gradientColors: config.colors.purpleGradient,
                    gradientStops: [1, 0],
                };

                this.opacityCover = 1;
                this.opacityValue[1] = 1;
                this.isLoading = true;
                if (this.scrapWCO) {
                    await this.$nextTick();
                    await new Promise(resolve => setTimeout(resolve, 500));

                    await this.scrapWCO.getDownload(
                        this.$refs.scrapWCO,
                        moment(generatedtime).format("DD MMMM YYYY, hh:mm A"),
                        this.selects.servicelocation,
                        startdate.toString(),
                        enddate.toString(),
                        api
                    );

                    this.getData();
                    this.opacityValue[1] = 0;
                    this.opacityCover = 0;
                    this.isLoading = false;
                }
            } else if (route == 'SWWCO') {
                this.swwco = false;

                let bardata = [];
                let barlabel = [];

                // await this.$http.get("/api/v1/report/monthly_sw_collection?start_date=2024-01-01&end_date=2024-12-31&service_location_id").then((res) => {
                await this.$http.get(":10001/api/v1/report/monthly_scrap_collection?start_date=" + startdate + "&end_date=" + enddate + "&service_location_id=" + this.selects.servicelocation).then((res) => {
                    if (!res.error) {
                        let response = res.message;

                        if (response.BarGraph !== null)
                            for (var i = 0; i < response.BarGraph.Label.length; i++) {
                                bardata.push(response.BarGraph.Value[i]);
                                barlabel.push(response.BarGraph.Label[i]);
                            }

                        // this.totalswwco = response.Total;
                    }
                });

                this.swwco = {
                    chartData: {
                        labels: barlabel,
                        datasets: [
                            {
                                label: "SW Code",
                                barPercentage: 0.3,
                                borderRadius: 10,
                                borderWidth: 0.3,
                                radius: 5,

                                fill: true,
                                backgroundColor: (ctx) => {
                                    const canvas = ctx.chart.ctx;
                                    const gradient = canvas.createLinearGradient(
                                        0,
                                        0,
                                        0,
                                        160
                                    );

                                    gradient.addColorStop(0, "#4472C4");
                                    gradient.addColorStop(1, "#4472C4");

                                    return gradient;
                                },
                                tension: 0.25,
                                data: bardata,
                            },
                        ],
                    },
                    loaded: true,
                    extraOptions: chartConfigs.barChartOptionsGradient3,
                    gradientColors: config.colors.purpleGradient,
                    gradientStops: [1, 0],
                };

                this.opacityCover = 1;
                this.opacityValue[2] = 1;
                this.isLoading = true;
                if (this.swWCO) {
                    await this.$nextTick();
                    await new Promise(resolve => setTimeout(resolve, 500));

                    await this.swWCO.getDownload(
                        this.$refs.swWCO,
                        moment(generatedtime).format("DD MMMM YYYY, hh:mm A"),
                        this.selects.servicelocation,
                        startdate.toString(),
                        enddate.toString(),
                        api
                    );
                    this.getData();
                    this.opacityValue[2] = 0;
                    this.opacityCover = 0;
                    this.isLoading = false;
                }
            } else if (route == 'TyreWCO') {
                this.tyrewco = false;

                let bardata = [];
                let barlabel = [];

                // await this.$http.get("/api/v1/report/monthly_tyre_collection?start_date=2024-01-01&end_date=2024-12-31&service_location_id").then((res) => {
                await this.$http.get(":10001/api/v1/report/monthly_scrap_collection?start_date=" + startdate + "&end_date=" + enddate + "&service_location_id=" + this.selects.servicelocation).then((res) => {
                    if (!res.error) {
                        let response = res.message;

                        if (response.BarGraph !== null)
                            for (var i = 0; i < response.BarGraph.Label.length; i++) {
                                bardata.push(response.BarGraph.Value[i]);
                                barlabel.push(response.BarGraph.Label[i]);
                            }

                        this.totaltyrewco = response.Total;
                    }
                });

                this.tyrewco = {
                    chartData: {
                        labels: barlabel,
                        datasets: [
                            {
                                label: "Waste Size",
                                barPercentage: 0.3,
                                borderRadius: 10,
                                borderWidth: 0.3,
                                radius: 5,

                                fill: true,
                                backgroundColor: (ctx) => {
                                    const canvas = ctx.chart.ctx;
                                    const gradient = canvas.createLinearGradient(
                                        0,
                                        0,
                                        0,
                                        160
                                    );

                                    gradient.addColorStop(0, "#4472C4");
                                    gradient.addColorStop(1, "#4472C4");

                                    return gradient;
                                },
                                tension: 0.25,
                                data: bardata,
                            },
                        ],
                    },
                    loaded: true,
                    extraOptions: chartConfigs.barChartOptionsGradient3,
                    gradientColors: config.colors.purpleGradient,
                    gradientStops: [1, 0],
                };

                this.opacityCover = 1;
                this.opacityValue[3] = 1;
                this.isLoading = true;
                if (this.tyreWCO) {
                    await this.$nextTick();
                    await new Promise(resolve => setTimeout(resolve, 500));

                    await this.tyreWCO.getDownload(
                        this.$refs.tyreWCO,
                        moment(generatedtime).format("DD MMMM YYYY, hh:mm A"),
                        this.selects.servicelocation,
                        startdate.toString(),
                        enddate.toString(),
                        api
                    );
                    this.getData();
                    this.opacityValue[3] = 0;
                    this.opacityCover = 0;
                    this.isLoading = false;
                }
            } else if (route == 'VesselGeneratedWaste') {
                let formatter = new Intl.NumberFormat("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });

                this.vesselchart1 = false;
                this.vesselchart2 = false;
                this.vesselchart3 = false;

                let bardata = [];
                let barlabel = [];

                let oiltanker = [];
                let chemicaltanker = [];
                let bulkcarrier = [];
                let container = [];
                let othercargo = [];
                let passengership = [];
                let others = [];

                let bardata2 = [];
                let barlabel2 = [];

                let bardata3 = [];
                let barlabel3 = [];

                // await this.$http.get("/api/v1/report/monthly_authority?start_date=2024-01-01&end_date=2024-12-31&service_location_id").then((res) => {
                await this.$http.get(":10001/api/v1/report/monthly_authority?start_date=" + startdate + "&end_date=" + enddate + "&service_location_id=" + this.selects.servicelocation).then((res) => {
                    if (!res.error) {
                        let response = res.message;

                        let total = 0;

                        if (response.ShipType !== null) {
                            for (var i = 0; i < response.ShipType.length; i++) {
                                total += response.ShipType[i].TotalCumulative;
                                // bardata.push(response.JobData.Value[i]);
                                // barlabel.push(response.JobData.Label[i]);
                            }

                            for (var i = 0; i < response.ShipType[1].Label.length; i++) {
                                bulkcarrier.push(response.ShipType[0].Value[i]);
                                chemicaltanker.push(response.ShipType[1].Value[i]);
                                container.push(response.ShipType[2].Value[i]);
                                oiltanker.push(response.ShipType[3].Value[i]);
                                passengership.push(response.ShipType[4].Value[i]);
                                othercargo.push(response.ShipType[5].Value[i]);
                                others.push(response.ShipType[6].Value[i]);
                                barlabel.push(response.ShipType[0].Label[i]);
                            }

                            this.totalcumulativeship = formatter.format(total).toString();
                        }

                        if (response.VolumeDischarge !== null) {
                            for (var i = 0; i < response.VolumeDischarge.Label.length; i++) {
                                bardata2.push(response.VolumeDischarge.Value[i]);
                                barlabel2.push(response.VolumeDischarge.Label[i]);
                            }
                            // console.log('wht', response.VolumeDischarge.TotalCumulative);
                            this.totalvolumedischarged = formatter.format(response.VolumeDischarge.TotalCumulative).toString();
                        }

                        if (response.VesselGenerated !== null)
                            for (var i = 0; i < response.VesselGenerated.length; i++) {
                                bardata3.push(response.VesselGenerated[i].TotalCollection);
                                barlabel3.push(`${response.VesselGenerated[i].Name} (${response.VesselGenerated[i].TotalCollection})`);
                            }
                        else
                            this.vesselchart3display = false;
                    }
                });

                this.vesselchart1 = {
                    chartData: {
                        labels: barlabel,
                        datasets: [
                            {
                                yAxisID: "y-axis-1",
                                type: "line",
                                label: "Oil Tanker",
                                fill: false,
                                borderColor: "#7ED3D0",
                                borderWidth: 2,
                                borderDash: [],
                                borderDashOffset: 0.0,
                                pointBackgroundColor: "#7ED3D0",
                                pointBorderColor: "rgba(255,255,255,0)",
                                pointHoverBackgroundColor: "#7ED3D0",
                                pointBorderWidth: 20,
                                pointHoverRadius: 4,
                                pointHoverBorderWidth: 15,
                                pointRadius: 4,
                                data: oiltanker,
                            },
                            {
                                yAxisID: "y-axis-2",
                                type: "line",
                                label: "Chemical Tanker",
                                fill: false,
                                borderColor: "#247BB5",
                                borderWidth: 2,
                                borderDash: [],
                                borderDashOffset: 0.0,
                                pointBackgroundColor: "#247BB5",
                                pointBorderColor: "rgba(255,255,255,0)",
                                pointHoverBackgroundColor: "#247BB5",
                                pointBorderWidth: 20,
                                pointHoverRadius: 4,
                                pointHoverBorderWidth: 15,
                                pointRadius: 4,
                                data: chemicaltanker,
                            },
                            {
                                yAxisID: "y-axis-2",
                                type: "line",
                                label: "Bulk Carrier",
                                fill: false,
                                borderColor: "#A8CFE3",
                                borderWidth: 2,
                                borderDash: [],
                                borderDashOffset: 0.0,
                                pointBackgroundColor: "#A8CFE3",
                                pointBorderColor: "rgba(255,255,255,0)",
                                pointHoverBackgroundColor: "#A8CFE3",
                                pointBorderWidth: 20,
                                pointHoverRadius: 4,
                                pointHoverBorderWidth: 15,
                                pointRadius: 4,
                                data: bulkcarrier,
                            },
                            {
                                yAxisID: "y-axis-2",
                                type: "line",
                                label: "Container",
                                fill: false,
                                borderColor: "#B2DF8A",
                                borderWidth: 2,
                                borderDash: [],
                                borderDashOffset: 0.0,
                                pointBackgroundColor: "#B2DF8A",
                                pointBorderColor: "rgba(255,255,255,0)",
                                pointHoverBackgroundColor: "#B2DF8A",
                                pointBorderWidth: 20,
                                pointHoverRadius: 4,
                                pointHoverBorderWidth: 15,
                                pointRadius: 4,
                                data: container,
                            },
                            {
                                yAxisID: "y-axis-2",
                                type: "line",
                                label: "Other Cargo Ship",
                                fill: false,
                                borderColor: "#FDC884",
                                borderWidth: 2,
                                borderDash: [],
                                borderDashOffset: 0.0,
                                pointBackgroundColor: "#FDC884",
                                pointBorderColor: "rgba(255,255,255,0)",
                                pointHoverBackgroundColor: "#FDC884",
                                pointBorderWidth: 20,
                                pointHoverRadius: 4,
                                pointHoverBorderWidth: 15,
                                pointRadius: 4,
                                data: othercargo,
                            },
                            {
                                yAxisID: "y-axis-2",
                                type: "line",
                                label: "Passenger Ship",
                                fill: false,
                                borderColor: "#DADADA",
                                borderWidth: 2,
                                borderDash: [],
                                borderDashOffset: 0.0,
                                pointBackgroundColor: "#DADADA",
                                pointBorderColor: "rgba(255,255,255,0)",
                                pointHoverBackgroundColor: "#DADADA",
                                pointBorderWidth: 20,
                                pointHoverRadius: 4,
                                pointHoverBorderWidth: 15,
                                pointRadius: 4,
                                data: passengership,
                            },
                            {
                                yAxisID: "y-axis-2",
                                type: "line",
                                label: "Others",
                                fill: false,
                                borderColor: "#87C683",
                                borderWidth: 2,
                                borderDash: [],
                                borderDashOffset: 0.0,
                                pointBackgroundColor: "#87C683",
                                pointBorderColor: "rgba(255,255,255,0)",
                                pointHoverBackgroundColor: "#87C683",
                                pointBorderWidth: 20,
                                pointHoverRadius: 4,
                                pointHoverBorderWidth: 15,
                                pointRadius: 4,
                                data: others,
                            },
                        ],
                    },
                    loaded: true,

                    extraOptions: chartConfigs.purpleChartOptionsllls,
                    gradientColors: config.colors.primaryGradient,
                    gradientStops: [1, 1, 1],
                };

                this.vesselchart3 = {
                    chartData: {
                        labels: barlabel3,
                        datasets: [
                            {
                                label: 'Emails',
                                pointRadius: 0,
                                pointHoverRadius: 0,
                                backgroundColor: ['#3595C6', '#32BBB7', '#32A02D', '#C1C1C1', '#EBEBEB'],
                                borderWidth: 0,
                                data: bardata3,
                            }
                        ]
                    },
                    extraOptions: {
                        maintainAspectRatio: false,
                        legend: {
                            display: true,
                            position: "bottom",
                            labels: {
                                usePointStyle: true,
                                pointStyle: {
                                    margin: "10px",
                                },
                                boxWidth: 10,
                                fontColor: "gray",
                            },
                        },
                        elements: {
                            center: {
                                text: "",
                                //   color: "#000000", // Default is #000000
                                fontStyle: "Poppins", // Default is Arial
                                sidePadding: 20, // Default is 20 (as a percentage)
                                minFontSize: 20, // Default is 20 (in px), set to false and text will not wrap.
                                lineHeight: 30, // Default is 25 (in px), used for when text wraps
                            },
                        },
                        responsive: true,
                        cutoutPercentage: 80,
                        tooltips: {
                            backgroundColor: "#f5f5f5",
                            titleFontColor: "#333",
                            bodyFontColor: "#666",
                            bodySpacing: 4,
                            xPadding: 12,
                            mode: "nearest",
                            intersect: 0,
                            position: "nearest",
                        },
                        animation: {
                            duration: 500,
                            onComplete: function (chart) {
                                if (chart.chart.config.options.elements.center) {
                                    // Get ctx from string
                                    var ctx = chart.chart.ctx;

                                    ctx.textAlign = "center";
                                    ctx.textBaseline = "middle";
                                    var centerX =
                                        (chart.chart.chartArea.left + chart.chart.chartArea.right) /
                                        2;
                                    var centerY =
                                        (chart.chart.chartArea.top + chart.chart.chartArea.bottom) /
                                        2;

                                    //Draw text in center
                                    ctx.font = " 20px Poppins, sans-serif";
                                    ctx.fillStyle = "#000000";
                                    ctx.fillText("Vessel", centerX, centerY - 10);
                                    ctx.fillText("generated", centerX, centerY + 15);
                                }
                            },
                        },

                        scales: {
                            yAxes: [
                                {
                                    display: 0,
                                    ticks: {
                                        display: false,
                                    },
                                    gridLines: {
                                        drawBorder: false,
                                        zeroLineColor: "transparent",
                                        color: "rgba(255,255,255,0.05)",
                                    },
                                },
                            ],

                            xAxes: [
                                {
                                    display: 0,
                                    barPercentage: 1.6,
                                    gridLines: {
                                        drawBorder: false,
                                        color: "rgba(255,255,255,0.1)",
                                        zeroLineColor: "transparent",
                                    },
                                    ticks: {
                                        display: false,
                                    },
                                },
                            ],
                        },
                    },
                    // extraOptions: chartConfigs.pieChartOptions15
                };

                this.vesselchart2 = {
                    chartData: {
                        labels: barlabel2,
                        datasets: [
                            {
                                label: "Volume of Discharged",
                                barPercentage: 0.3,
                                borderRadius: 10,
                                borderWidth: 0.3,
                                radius: 5,

                                fill: true,
                                backgroundColor: (ctx) => {
                                    const canvas = ctx.chart.ctx;
                                    const gradient = canvas.createLinearGradient(
                                        0,
                                        0,
                                        0,
                                        160
                                    );

                                    gradient.addColorStop(0, "#3495c6");
                                    gradient.addColorStop(1, "#3495c6");

                                    return gradient;
                                },
                                tension: 0.25,
                                data: bardata2,
                            },
                        ],
                    },
                    loaded: true,
                    extraOptions: chartConfigs.barChartOptionsGradient3,
                    gradientColors: config.colors.purpleGradient,
                    gradientStops: [1, 0],
                };

                this.opacityCover = 1;
                this.opacityValue[4] = 1;
                this.isLoading = true;
                if (this.vesselGeneratedWaste) {
                    await this.$nextTick();
                    await new Promise(resolve => setTimeout(resolve, 500));

                    await this.vesselGeneratedWaste.getDownload(
                        this.$refs.vesselGeneratedWaste,
                        moment(generatedtime).format("DD MMMM YYYY, hh:mm A"),
                        this.selects.servicelocation,
                        startdate.toString(),
                        enddate.toString(),
                        api
                    );
                    this.getData();
                    this.opacityValue[4] = 0;
                    this.opacityCover = 0;
                    this.isLoading = false;
                }
            } else if (route == 'VesselsBerthVolume') {
                this.isLoading = true;
                if (this.vesselsBerthVolume) {
                    this.vesselsBerthVolume.getDownload(
                        moment(generatedtime).format("DD MMMM YYYY, hh:mm A"),
                        this.selects.servicelocation,
                        startdate.toString(),
                        enddate.toString(),
                        api
                    );
                    this.getData();
                    this.isLoading = false;
                }
            } else if (route == 'WCOOverall') {
                this.wcooverall = false;

                let bardata = [];
                let barlabel = [];

                // await this.$http.get("/api/v1/report/monthly_wco_list?start_date=2024-01-01&end_date=2024-12-31&service_location_id").then((res) => {
                await this.$http.get(":10001/api/v1/report/monthly_wco_list?start_date=" + startdate + "&end_date=" + enddate + "&service_location_id=" + this.selects.servicelocation).then((res) => {
                    if (!res.error) {
                        let response = res.message;

                        if (response.JobData !== null)
                            for (var i = 0; i < response.JobData.Label.length; i++) {
                                bardata.push(response.JobData.Value[i]);
                                barlabel.push(`${response.JobData.Label[i]} (${response.JobData.Value[i]})`);
                            }
                        else
                            this.wcooveralldisplay = false;
                    }
                });

                this.wcooverall = {
                    chartData: {
                        labels: barlabel,
                        datasets: [
                            {
                                label: 'Emails',
                                pointRadius: 0,
                                pointHoverRadius: 0,
                                backgroundColor: ['#4472C4', '#ED7D31', '#A5A5A5', '#FFC102', '#5B9BD5'],
                                borderWidth: 0,
                                data: bardata,
                            }
                        ]
                    },
                    extraOptions: chartConfigs.pieChartOptions15
                };

                this.opacityCover = 1;
                this.opacityValue[5] = 1;
                this.isLoading = true;
                if (this.wcoOverall) {
                    await this.$nextTick();
                    await new Promise(resolve => setTimeout(resolve, 500));

                    await this.wcoOverall.getDownload(
                        this.$refs.wcoOverall,
                        moment(generatedtime).format("DD MMMM YYYY, hh:mm A"),
                        this.selects.servicelocation,
                        startdate.toString(),
                        enddate.toString(),
                        api,
                        this.wcooveralldisplay
                    );
                    this.getData();
                    this.opacityValue[5] = 0;
                    this.opacityCover = 0;
                    this.isLoading = false;
                }
            } else if (route == 'WDO') {
                this.wdochart = false;

                let bardata = [];
                let barlabel = [];

                // await this.$http.get("/api/v1/report/monthly_wdo_list?start_date=2024-01-01&end_date=2024-12-31&service_location_id").then((res) => {
                await this.$http.get(":10001/api/v1/report/monthly_wdo_list?start_date=" + startdate + "&end_date=" + enddate + "&service_location_id=" + this.selects.servicelocation).then((res) => {
                    if (!res.error) {
                        let response = res.message;

                        if (response.JobData !== null)
                            for (var i = 0; i < response.JobData.Label.length; i++) {
                                bardata.push(response.JobData.Value[i]);
                                barlabel.push(`${response.JobData.Label[i]} (${response.JobData.Value[i]})`);
                            }
                        else
                            this.wdochartdisplay = false;

                    }
                });

                this.wdochart = {
                    chartData: {
                        labels: barlabel,
                        datasets: [
                            {
                                label: 'Emails',
                                pointRadius: 0,
                                pointHoverRadius: 0,
                                backgroundColor: ['#4472C4', '#ED7D31', '#A5A5A5', '#FFC102', '#5B9BD5'],
                                borderWidth: 0,
                                data: bardata,
                            }
                        ]
                    },
                    extraOptions: chartConfigs.pieChartOptions15
                };

                this.opacityCover = 1;
                this.opacityValue[6] = 1;
                this.isLoading = true;
                if (this.wdo) {
                    await this.$nextTick();
                    await new Promise(resolve => setTimeout(resolve, 500));

                    await this.wdo.getDownload(
                        this.$refs.wdo,
                        moment(generatedtime).format("DD MMMM YYYY, hh:mm A"),
                        this.selects.servicelocation,
                        startdate.toString(),
                        enddate.toString(),
                        api,
                        this.wdochartdisplay
                    );
                    this.getData();
                    this.opacityValue[6] = 0;
                    this.opacityCover = 0;
                    this.isLoading = false;
                }
            } else if (route == 'WDR') {
                this.wdrchart1 = false;
                this.wdrchart2 = false;
                this.wdrchart3 = false;

                let bardata = [];
                let barlabel = [];

                let bardata2 = [];
                let barlabel2 = [];

                let bardata3 = [];
                let barlabel3 = [];

                // await this.$http.get("/api/v1/report/monthly_wdr_list?start_date=2024-01-01&end_date=2024-12-31&service_location_id").then((res) => {
                await this.$http.get(":10001/api/v1/report/monthly_wdr_list?start_date=" + startdate + "&end_date=" + enddate + "&service_location_id=" + this.selects.servicelocation).then((res) => {
                    if (!res.error) {
                        let response = res.message;

                        if (response.JobData !== null)
                            for (var i = 0; i < response.JobData.Label.length; i++) {
                                bardata.push(response.JobData.Value[i]);
                                barlabel.push(`${response.JobData.Label[i]} (${response.JobData.Value[i]})`);
                            }
                        else
                            this.wdrchart1display = false;

                        if (response.TonnageData !== null)
                            for (var i = 0; i < response.TonnageData.Label.length; i++) {
                                bardata2.push(response.TonnageData.Value[i]);
                                barlabel2.push(`${response.TonnageData.Label[i]} (${response.TonnageData.Value[i]})`);
                            }
                        else
                            this.wdrchart2display = false;

                        if (response.TonnageData !== null)
                            for (var i = 0; i < response.TonnageData.Label.length; i++) {
                                bardata3.push(response.TonnageData.Value[i]);
                                barlabel3.push(response.TonnageData.Label[i]);
                            }
                    }
                });

                this.wdrchart1 = {
                    chartData: {
                        labels: barlabel,
                        datasets: [
                            {
                                label: 'Emails',
                                pointRadius: 0,
                                pointHoverRadius: 0,
                                backgroundColor: ['#4472C4', '#ED7D31', '#A5A5A5', '#FFC102', '#5B9BD5'],
                                borderWidth: 0,
                                data: bardata,
                            }
                        ]
                    },
                    extraOptions: chartConfigs.pieChartOptions15
                };

                this.wdrchart2 = {
                    chartData: {
                        labels: barlabel2,
                        datasets: [
                            {
                                label: 'Emails',
                                pointRadius: 0,
                                pointHoverRadius: 0,
                                backgroundColor: ['#4472C4', '#ED7D31', '#A5A5A5', '#FFC102', '#5B9BD5'],
                                borderWidth: 0,
                                data: bardata2,
                            }
                        ]
                    },
                    extraOptions: chartConfigs.pieChartOptions15
                };

                this.wdrchart3 = {
                    chartData: {
                        labels: barlabel3,
                        datasets: [
                            {
                                type: "line",
                                label: "WDR",
                                fill: false,
                                borderColor: "rgba(68, 114, 196, 1)",
                                borderWidth: 2,
                                borderDash: [],
                                borderDashOffset: 0.0,
                                pointBackgroundColor: "rgba(68, 114, 196, 1)",
                                pointBorderColor: "rgba(255,255,255,0)",
                                pointHoverBackgroundColor: config.colors.danger,
                                pointBorderWidth: 20,
                                pointHoverRadius: 4,
                                pointHoverBorderWidth: 15,
                                pointRadius: 4,
                                data: bardata2,

                            },
                            {
                                label: "Tonnage WDR",
                                barPercentage: 0.3,
                                borderRadius: 10,
                                borderWidth: 0.3,
                                radius: 5,

                                fill: true,
                                backgroundColor: (ctx) => {
                                    const canvas = ctx.chart.ctx;
                                    const gradient = canvas.createLinearGradient(
                                        0,
                                        0,
                                        0,
                                        160
                                    );

                                    gradient.addColorStop(0, "#ED7D31");
                                    gradient.addColorStop(1, "#ED7D31");

                                    return gradient;
                                },
                                tension: 0.25,
                                data: bardata3,
                            },

                        ],
                    },
                    loaded: true,
                    extraOptions: chartConfigs.barChartOptionsGradient3,
                    gradientColors: config.colors.purpleGradient,
                    gradientStops: [1, 0],
                };

                this.opacityCover = 1;
                this.opacityValue[7] = 1;
                this.isLoading = true;
                if (this.wdr) {
                    await this.$nextTick();
                    await new Promise(resolve => setTimeout(resolve, 500));

                    await this.wdr.getDownload(
                        this.$refs.wdr,
                        moment(generatedtime).format("DD MMMM YYYY, hh:mm A"),
                        this.selects.servicelocation,
                        startdate.toString(),
                        enddate.toString(),
                        api
                    );
                    this.getData();
                    this.opacityValue[7] = 0;
                    this.opacityCover = 0;
                    this.isLoading = false;
                }
            }
            this.selects.date = "";
            this.selects.servicelocation = "";
        },
        getReport(route, api) {
            this.$router.push({
                path: "Reports/" + route,
                query: { apiData: api }
            });
        },
        getData() {
            this.load = true;
            this.tableDatas = [];

            this.$http.get(":10001/api/v1/report").then((res) => {
                if (!res.error) {
                    let response = res.message;

                    console.log('data dia', response);
                    let routename = '';

                    for (var i = 0; i < response.length; i++) {
                        if (response[i].Name == 'Vessel Generated Waste') {
                            routename = 'VesselGeneratedWaste';
                        } else if (response[i].Name == 'Waste Collection Order (Garbage)') {
                            routename = 'GarbageWCO';
                        } else if (response[i].Name == 'Waste Collection Order (Scrap)') {
                            routename = 'ScrapWCO';
                        } else if (response[i].Name == 'Waste Collection Order (Schedule Waste & Washwater)') {
                            routename = 'SWWCO';
                        } else if (response[i].Name == 'Waste Collection Order (Tyre)') {
                            routename = 'TyreWCO';
                        } else if (response[i].Name == 'Waste Delivery Order (WDO)') {
                            routename = 'WDO';
                        } else if (response[i].Name == 'Waste Delivery Receipt (WDR)') {
                            routename = 'WDR';
                        } else if (response[i].Name == 'Waste Collection Order (WCO)') {
                            routename = 'WCOOverall';
                        } else if (response[i].Name == 'Vessel Berth and Volume') {
                            routename = 'VesselsBerthVolume';
                        } else if (response[i].Name == 'Revenue Sharing') {
                            routename = 'RevenueSharing';
                        }

                        let obj = {
                            reportname: response[i].Name,
                            lastgenerated: response[i].LastGeneratedAt == null ? '-' : moment(response[i].LastGeneratedAt).format("YYYY-MM-DD HH:mm"),
                            route: routename,
                            api: response[i].Api,
                        };

                        this.tableDatas.push(obj);
                    }

                    this.load = false;
                }
            });
        },
        getServiceLocation() {
            this.selects.servicelocations = [];

            this.$http.get(":10001/api/v1/reference/service-location").then((res) => {
                if (!res.error) {
                    let response = res.message;

                    for (var i = 0; i < response.length; i++) {
                        let obj = {
                            label: response[i].Location,
                            value: response[i].ServiceLocationId,
                        };
                        this.selects.servicelocations.push(obj);
                    }
                }
            });
        },
    },
    created() {
        this.garbageWCO = new (Vue.extend(GarbageWCO))();
        this.revenueSharing = new (Vue.extend(RevenueSharing))();
        this.scrapWCO = new (Vue.extend(ScrapWCO))();
        this.swWCO = new (Vue.extend(SWWCO))();
        this.tyreWCO = new (Vue.extend(TyreWCO))();
        this.vesselGeneratedWaste = new (Vue.extend(VesselGeneratedWaste))();
        this.vesselsBerthVolume = new (Vue.extend(VesselsBerthVolume))();
        this.wcoOverall = new (Vue.extend(WCOOverall))();
        this.wdo = new (Vue.extend(WDO))();
        this.wdr = new (Vue.extend(WDR))();
        this.getServiceLocation();
        this.getData();
    },
    computed: {
        cangenerate() {
            return this.selects.date === "" || this.selects.servicelocation === '';
        },
    },
};
</script>
<style>
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}
</style>